import { PATHS, QUERY_PARAMS } from "./constants";

export const createCustomerFormLink = (orgId: string) => {
    const domain = window.location.origin
    return `${domain}${PATHS.NEW}/${orgId}`
}

export const createUserInvitationLink = (domain: string, orgId: string, invitationId: string) =>
    `${domain}${PATHS.INVITE}?${QUERY_PARAMS.ORG_ID}=${orgId}&${QUERY_PARAMS.ID}=${invitationId}`

export const createAuthLink = (domain: string, tokenId: string) =>
    `${domain}?${QUERY_PARAMS.AUTH_TOKEN}=${tokenId}`


interface ShareTokenLinkOptions {
    offer?: boolean;
    invoice?: boolean;
    domain?: string;
}
export const createShareTokenLink = (tokenId: string, options: ShareTokenLinkOptions = {}) => {
    const domain = options.domain || window.location.origin;

    let path = PATHS.SHARED;
    if (options.offer) {
        path = PATHS.OFFERS;
    } else if (options.invoice) {
        path = PATHS.INVOICES;
    }

    return `${domain}${path}/${tokenId}`
}


